import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';

const WishlistEager = lazy(
  () =>
    import('./WishlistPage.eager').then(mod => ({
      default: mod.WishlistPageEager,
    })),
  {
    aboveTheFold: true,
  },
);

export const WishlistPage = () => {
  return <WishlistEager />;
};
